import React, { useState, useEffect } from 'react';
import './Menu.css';
import { AiOutlineClose } from 'react-icons/ai';
import { IoHomeOutline, IoShareSocialOutline, IoStorefrontOutline, IoGridOutline, IoCartOutline, IoPricetagsOutline, IoIceCreamOutline, IoVideocamOutline } from "react-icons/io5";
import { LiaDollySolid } from "react-icons/lia";
import { HiOutlinePaintBrush, HiOutlineUsers } from "react-icons/hi2";
import { BsCartPlus, BsCash } from "react-icons/bs";
import { FiMenu } from 'react-icons/fi';
import { PiClipboardText } from 'react-icons/pi';
import MenuItem from './MenuItem';
import MenuRechargeCartaButton from './MenuRechargeCartaButton';
import MenuLogoutButton from './MenuLogoutButton';
import {useConfig} from "../../context/ConfigContext";
import {GoGear, GoPerson} from "react-icons/go";
import { TbListNumbers } from "react-icons/tb";
import {getUserRoleFromToken} from "../../auth/authUtils";

export default function Menu() {
    const [isOpen, setIsOpen] = useState(false);
    const [isMobile, setIsMobile] = useState(false);

    const userRole = getUserRoleFromToken();

    // Función para verificar el tamaño de la pantalla y definir si es móvil o no
    const handleResize = () => {
        setIsMobile(window.innerWidth <= 768); // Define tamaño de pantalla móvil como <= 768px
    };

    useEffect(() => {
        handleResize(); // Verifica al montar el componente
        window.addEventListener('resize', handleResize); // Agrega evento de escucha para redimensionar

        return () => {
            window.removeEventListener('resize', handleResize); // Limpia evento al desmontar componente
        };
    }, []);

    // MODULOS DE CONFIGURACIONES DE NEGOCIO
    const { features } = useConfig();
    const stockFeature = features.find(feature => feature.name === 'STOCK');
    const reportsFeature = features.find(feature => feature.name === 'REPORTES');
    const priceListFeature = features.find(feature => feature.name === 'LISTAS_PRECIOS');

    // Verificar si tiene activa alguna de las features
    const clientFeature = features.find(feature => feature.name === 'CLIENT' && feature.status === true);
    const invoicingFeature = features.find(feature => feature.name === 'FACTURACION' && feature.status === true);
    
    // Mostrar el menú de clientes si tiene alguna de las features activas
    const showClientMenu = clientFeature || invoicingFeature;

    const toggleSidebar = () => setIsOpen(!isOpen);
    const closeSidebar = () => setIsOpen(false);

    return (
        <>
            {isMobile ?
                (
                    <div className={`zindex menu-container ${isOpen ? 'open' : ''}`}>
                        {/* Botón de hamburguesa para abrir/cerrar el menú */}
                        <button className="menu-toggle-btn" onClick={toggleSidebar}>
                            {isOpen ? <AiOutlineClose/> : <FiMenu/>}
                        </button>

                        {/* Contenedor del menú que se despliega cuando isOpen es true */}
                        <nav className={`mobile-nav ${isOpen ? 'open' : 'closed'}`}>
                            <MenuItem isOpen={isOpen} path={"/home"} Icon={IoHomeOutline} text={"Inicio"} onClick={closeSidebar} />
                            {userRole === 'ADMIN' &&
                                <>
                                    <MenuItem isOpen={isOpen} path={"/shop"} Icon={IoStorefrontOutline} text={"Local/ Sucursales"} onClick={closeSidebar} />
                                    <MenuItem isOpen={isOpen} path={"/users"} Icon={HiOutlineUsers} text={"Usuarios"} onClick={closeSidebar} />
                            </>}
                            <MenuItem isOpen={isOpen} path={"/categories"} Icon={IoGridOutline} text={"Categorías"} onClick={closeSidebar} />
                            <MenuItem isOpen={isOpen} path={"/marcas"} Icon={IoPricetagsOutline} text={"Marcas"} onClick={closeSidebar} />
                            <MenuItem isOpen={isOpen} path={"/misProductos"} Icon={PiClipboardText} text={"Productos"} onClick={closeSidebar} />
                            <MenuItem isOpen={isOpen} path={"/flavors"} Icon={IoIceCreamOutline} text={"Gustos"} onClick={closeSidebar} />
                            <MenuItem isOpen={isOpen} path={"/personalizacion"} Icon={HiOutlinePaintBrush} text={"Diseño"} onClick={closeSidebar} />
                            <MenuItem isOpen={isOpen} path={"/pedidoMostrador"} Icon={BsCartPlus} text={"Crear pedido"} onClick={closeSidebar} />
                            <MenuItem isOpen={isOpen} path={"/orders"} Icon={IoCartOutline} text={"Pedidos"} onClick={closeSidebar} />
                            <MenuItem isOpen={isOpen} path={"/config"} Icon={GoGear} text={"Configuraciones"} onClick={closeSidebar}/>
                            {reportsFeature && reportsFeature.status && <MenuItem isOpen={isOpen} path={"/movements"} Icon={BsCash} text={"Movimientos"}/>}
                            {stockFeature && stockFeature.status && <MenuItem isOpen={isOpen} path={"/stock"} Icon={LiaDollySolid} text={"Stock"} onClick={closeSidebar}/>}
                            {showClientMenu && (
                                <MenuItem isOpen={isOpen} path={"/client"} Icon={GoPerson} text={"Clientes"}/>
                            )}
                            <MenuItem
                                isOpen={isOpen}
                                path={"/price-lists"}
                                Icon={TbListNumbers}
                                text={"Listas de Precios"}
                                onClick={closeSidebar}
                            />
                            <MenuItem isOpen={isOpen} path={"/gestion-video"} Icon={IoVideocamOutline} text={"Video"} onClick={closeSidebar}/>
                            <MenuRechargeCartaButton isOpen={isOpen}/>
                            {isOpen && <MenuLogoutButton isOpen={isOpen} isMobile={true}/>}
                        </nav>

                    </div>
                )
                :
                (
                    <div className={`zindex sidebar ${isOpen ? 'open' : 'closed'}`}>
                        <button onClick={toggleSidebar} className="toggle-btn">
                            {isOpen ? <AiOutlineClose/> : <FiMenu/>}
                        </button>

                        <nav className="menu-nav">
                            {/* Lista de items del menú */}
                            <MenuItem isOpen={isOpen} path={"/home"} Icon={IoHomeOutline} text={"Inicio"}/>
                            {userRole === 'ADMIN' &&
                                <>
                                    <MenuItem isOpen={isOpen} path={"/shop"} Icon={IoStorefrontOutline} text={"Local/ Sucursales"}/>
                                    <MenuItem isOpen={isOpen} path={"/users"} Icon={HiOutlineUsers} text={"Usuarios"} />
                                </>}
                            <MenuItem isOpen={isOpen} path={"/categories"} Icon={IoGridOutline} text={"Categorías"}/>
                            <MenuItem isOpen={isOpen} path={"/marcas"} Icon={IoPricetagsOutline} text={"Marcas"}/>
                            <MenuItem isOpen={isOpen} path={"/misProductos"} Icon={PiClipboardText} text={"Productos"}/>
                            <MenuItem isOpen={isOpen} path={"/flavors"} Icon={IoIceCreamOutline} text={"Gustos"}/>
                            <MenuItem isOpen={isOpen} path={"/personalizacion"} Icon={HiOutlinePaintBrush} text={"Diseño"}/>
                            <MenuItem isOpen={isOpen} path={"/pedidoMostrador"} Icon={BsCartPlus} text={"Crear pedido"}/>
                            <MenuItem isOpen={isOpen} path={"/orders"} Icon={IoCartOutline} text={"Pedidos"}/>
                            <MenuItem isOpen={isOpen} path={"/config"} Icon={GoGear} text={"Configuraciones"}/>
                            {reportsFeature && reportsFeature.status && <MenuItem isOpen={isOpen} path={"/movements"} Icon={BsCash} text={"Movimientos"}/>}
                            {showClientMenu && (
                                <MenuItem isOpen={isOpen} path={"/client"} Icon={GoPerson} text={"Clientes"}/>
                            )}
                            {stockFeature && stockFeature.status && <MenuItem isOpen={isOpen} path={"/stock"} Icon={LiaDollySolid} text={"Stock"}/>}
                            <MenuItem
                                isOpen={isOpen}
                                path={"/price-lists"}
                                Icon={TbListNumbers}
                                text={"Listas de Precios"}
                            />
                            <MenuItem isOpen={isOpen} path={"/gestion-video"} Icon={IoVideocamOutline} text={"Video"}/>
                            <MenuRechargeCartaButton isOpen={isOpen}/>
                        </nav>

                        <MenuLogoutButton isOpen={isOpen} isMobile={false}/>
                    </div>
                )
            }
        </>
    );
}
